import styled from 'styled-components'
import { mobile } from 'styles/responsive'

export const Name = styled.div`
    align-self: stretch;
    display: flex;
    align-items: center;

    span {
        font-weight: 700;
        font-size: 13px;
        line-height: 150%;
        text-transform: uppercase;
        display: inline-block;
    }

    img {
        display: inline-block;
    }

    ${mobile(`
        grid-column: span 2;
    `)}

    > * + * {
        margin-left: 5px;
    }
`

export const ImageTooltip = styled.img`
    cursor: pointer;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
`
